import { UserManager } from "oidc-client";

function controller() {
	new UserManager().signinSilentCallback()
		.catch(function(err) {
			// eslint-disable-next-line no-console
			console.log(err);
		});
}

export default angular
	.module("vesl.screens.public.silent-renew", [])
	.component("silentRenew", {
		template: "",
		controller
	}).name;
